var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-pill",class:{
    'is-online': _vm.statusKey.toLowerCase() === 'online',
    'is-offline': _vm.statusKey.toLowerCase() === 'offline',
  }},[_vm._v(" "+_vm._s(_vm.statusKey || 'Loading')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }